import moment from 'moment';

export class PearlsPlanningDeleteItem {
    id: number;
    title: string;
    date: Date;
    type: 'storecheck'|'event';
    constructor(id: number, title: string, date: Date, type: 'storecheck'|'event'){
        this.id = id;
        this.title = title;
        this.date = date;
        this.type = type;
    }
}

export class PearlsPlanningDeleteAgent {
    salesRepId: number;
    salesRepName: string;    
    items: Array<PearlsPlanningDeleteItem> = [];
    
    constructor(salesRepId: number, salesRepName: string){
        this.salesRepId = salesRepId;
        this.salesRepName = salesRepName;
    }
    
    static FromJson(json: any, includeEvents: boolean = true): Array<PearlsPlanningDeleteAgent>{
        let pearlsPlanningDeleteAgents: Array<PearlsPlanningDeleteAgent> = [];
        
        if(json.length > 0){
            for(let a of json){
                let agent = new PearlsPlanningDeleteAgent(a.salesRepId, a.salesRepName);
                
                if(a.storeChecks?.length > 0){
                    for(let s of a.storeChecks){
                        let d = moment(s.plannedStartDate, 'DD/MM/YYYY HH:mm').toDate();
                        agent.items.push(new PearlsPlanningDeleteItem(s.id, s.storeName, d, 'storecheck'));
                    }
                }
                
                if(includeEvents && a.events?.length > 0){
                    for(let e of a.events){
                        let d = moment(e.plannedStartDate, 'DD/MM/YYYY HH:mm').toDate();
                        agent.items.push(new PearlsPlanningDeleteItem(e.id, e.title, d, 'event'));
                    }
                }
                
                if(agent.items.length > 0){
                    agent.items.sort((a, b) => a.date.getTime() - b.date.getTime());
                    pearlsPlanningDeleteAgents.push(agent);
                }
            }
        }
        
        return pearlsPlanningDeleteAgents;
    }
}
